export default __webpack_public_path__ + "static/media/standfest-rechtsanwalt-immobilien.f543d4ae.svg";